import { jsx as _jsx } from "react/jsx-runtime";
import { integerNumberRegex, wholePositiveAndNegativeNumberWithSingleMinusRegex } from '@/core/utils/validation';
import { TextField } from '../TextField';
import { useForkRef } from '@mui/material';
import { forwardRef } from 'react';
import { getUnitLabel } from './getUnitLabel';
import { parseFloatInput } from './parseFloatInput';
/**
 * `ref` is forwarded to `inputRef`, the native `<input>`, so react-hook-form can focus the field on a validation error.
 * The root element that a plain `ref` would get is not focusable.
 */
const NumericFieldV2 = forwardRef(({ variant, unit, onChange, value, inputRef, ...props }, ref) => {
    const forkedInputRef = useForkRef(inputRef, ref);
    const adornment = unit ? { endAdornment: getUnitLabel(unit) } : {};
    return (_jsx(TextField, { value: value, ...props, ...adornment, inputRef: forkedInputRef, onChange: (event) => {
            const newValue = event.target.value;
            if (newValue === '') {
                onChange(null);
                return;
            }
            switch (variant) {
                case 'whole': {
                    if (integerNumberRegex.test(newValue)) {
                        onChange(Number(newValue));
                    }
                    break;
                }
                case 'wholeNegative': {
                    if (wholePositiveAndNegativeNumberWithSingleMinusRegex.test(newValue)) {
                        // '-' is not a number, but the user still has to be able to type it.
                        if (newValue === '-')
                            onChange(newValue);
                        else
                            onChange(Number(newValue));
                    }
                    break;
                }
                case 'float':
                case 'floatNegative': {
                    const parsed = parseFloatInput(newValue, { allowNegative: variant === 'floatNegative' });
                    if (parsed !== null)
                        onChange(parsed);
                    break;
                }
                default: {
                    const exhaustiveCheck = variant;
                    throw new Error(`Unhandled NumericField variant case: ${exhaustiveCheck}`);
                }
            }
        } }));
});
export { NumericFieldV2 };
